module.exports = __webpack_public_path__ + "img/03.aca3cb0e.png";